import { useServicesContext } from "@/modules/core/services/services.context"
import { SocialPostEntity } from "@/modules/social/entities/socialEntity"
import { socialKeys } from "@/modules/social/gateway/socialKeys"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"

export const useSessionSocialPost = (socialPostId: string) => {
  const { socialApi } = useServicesContext()

  return useSuspenseQuery({
    queryKey: socialKeys.sessionPost(socialPostId),
    queryFn: async () => {
      const dto = await socialApi.getSessionSocialPost(socialPostId)
      return SocialPostEntity.fromDto(dto)
    },
  })
}

export const useUserExerciseSocialPost = (userId: string, exerciseId: string) => {
  const { socialApi } = useServicesContext()

  return useQuery({
    queryKey: socialKeys.userExercisePost(userId, exerciseId),
    queryFn: async () => {
      const dto = await socialApi.getUserExerciseSocialPost(userId, exerciseId)
      if (!dto) {
        return null
      }
      return SocialPostEntity.fromDto(dto)
    },
  })
}
